import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { TransportOrderIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { Observable } from 'rxjs';
import { TransportOrderOverviewData } from '../../models/transport-order-overview.model';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { ShipmentTransportOrderEndpoint } from '../../constants';

@Injectable({ providedIn: 'root' })
export class TransportOrderOverviewService {
  constructor(private http: WrapperHttpService) {}

  getOverview(transportOrderIdView: TransportOrderIdView): Observable<TransportOrderOverviewData> {
    return this.http
      .withLoading()
      .get<TransportOrderOverviewData>(
        `${API_URL}${ShipmentTransportOrderEndpoint.Base}${ShipmentTransportOrderEndpoint.Tos}${
          ShipmentTransportOrderEndpoint.Overview
        }?${getQueryStringFromObject(transportOrderIdView)}`,
      );
  }
}
